import React, { useState, useEffect } from "react";
import { PaymentElement } from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { Typography, Button, CircularProgress, Alert, Divider, FormGroup, FormControlLabel,  Checkbox  } from '@mui/material';
import '../styles/common.css';
import langDetails from '../components/MultiLanguage/language.json';
import { sendIsCardSaveDetails, retrievePaymentDetails } from './redux/actions';

const CheckoutForm = ({handleNext, sharedData, updateSharedData, csKey}) => {
const stripe = useStripe();
const elements = useElements();
const [errorMessage, setErrorMessage] = useState('');
const [isProcessing, setIsProcessing] = useState(false);
const [saveCardForFutureUse, setSaveCardForFutureUse] = useState(false);
const [paymentProcessing, setPaymentProcessing] = useState({});
const [uniquePaymentCardDetails, setUniquePaymentCardDetails] = useState([]);

useEffect(() => {
  const seenCombinations = new Set();
  const filteredData = sharedData?.paymentIntent?.paymentCardDetails?.cardDetails?.filter(entry => {
    const combination = `${entry.cardExpiryMonth}-${entry.cardExpiryYear}-${entry.cardLastFourDigit}`;
    if (seenCombinations?.has(combination)) {
      return false; // Duplicate entry, filter it out
    } else {
      seenCombinations?.add(combination);
      return true; // Unique entry, keep it
    }
  });
  setUniquePaymentCardDetails(filteredData);
}, [sharedData?.paymentIntent?.paymentCardDetails?.cardDetails]); 

const handleCheckboxChange = (event) => {
  setSaveCardForFutureUse(event.target.checked);
};

const lang = langDetails[sharedData?.language];

useEffect(() => {
  if (!stripe) {
    return;
  }
  const clientSecret = new URLSearchParams(window.location.search).get(
      'payment_intent_client_secret'
    );
  if (!clientSecret) {
    return;
  }
}, [stripe]);

const handleConfirmDirectPay = async (paymentMethodId) => {
  setPaymentProcessing((prevProcessing) => ({
    ...prevProcessing,
    [paymentMethodId]: true,
  }));


  try {
    const { paymentIntent, error } = await stripe.confirmCardPayment(
      csKey,
      {
        payment_method: paymentMethodId,
      }
    );

    if (error) {
      setPaymentProcessing((prevProcessing) => ({
        ...prevProcessing,
        [paymentMethodId]: false,
      }));

      // Subscription's first PaymentIntent is already succeeded — treat as success
      if (error.code === 'payment_intent_unexpected_state' && error.payment_intent?.status === 'succeeded') {
        const updatedData = {
          ...sharedData,
          paymentIntent: {
            ...sharedData.paymentIntent,
            paymentIntentId: error.payment_intent.id,
          },
          singlePaymentMethodId: paymentMethodId,
        };
        updateSharedData(updatedData);
        confimPaymentDetails(updatedData);
        return;
      }

      console.error('Error confirming payment:', error);
    } else if (paymentIntent && paymentIntent.status === 'succeeded') {
      setPaymentProcessing((prevProcessing) => ({
        ...prevProcessing,
        [paymentMethodId]: false,
      }));
  
      if (paymentIntent.status === 'succeeded') {
          const updatedData = {
            ...sharedData,
            paymentIntent: {
              ...sharedData.paymentIntent,
              "paymentIntentId": paymentIntent.id,
            },
            singlePaymentMethodId: paymentMethodId
          };
          updateSharedData(updatedData);
          confimPaymentDetails(updatedData)
          // if(sharedData?.isArtistOrInfluencer && sharedData?.userId && sharedData?.userId !== "None") {
          //   handleNext(2)
          // } else {
          //   handleNext(4);
          // }
        } else {
          setErrorMessage(lang?.unexpectedPaymentStatus, paymentIntent.status)
          console.log('Unexpected payment status:', paymentIntent.status);
        }
    }
  } catch (error) {
    console.error('Error:', error);
  }
};


const handleSubmit = async (e) => {
  e.preventDefault();
  const payload = {
    paymentIntentId: sharedData?.paymentIntent?.paymentIntentId,
    isSaveCardDetails: saveCardForFutureUse,
    userId: sharedData?.userId  !== "None"  ? sharedData?.userId : null,
  }

  sendIsCardSaveDetails(payload).then((response) => {
    if(response.code && response.code  !== "") {
      return
    }
    if (response && response.data && response.data.status === 200) {
        confirmStripePayment();
    }
  })
  .catch((error) => {
    console.error('Error fetching data:', error);
  });
 
  };
  const confirmStripePayment = async() => {
    if (!stripe || !elements) {
      return;
    }
    setIsProcessing(true);
    const { paymentIntent, error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
      },
      redirect: 'if_required'
    })
    // if (error.type === "card_error" || error.type === "validation_error") {
    //   setErrorMessage(error.message);
    // } 
    if (error) {
        console.error("Client-side error:", error.message);
        setIsProcessing(false);
      } else if (paymentIntent) {
        setIsProcessing(false);
        if (paymentIntent.status === 'succeeded') {
            const updatedData = {
              ...sharedData,
              "isSaveCardDetails": saveCardForFutureUse,
              paymentIntent: {
                ...sharedData.paymentIntent,
                "paymentIntentId": paymentIntent.id,
              },
              paymentMethodID: paymentIntent?.payment_method,
              singlePaymentMethodId: paymentIntent?.payment_method
            };
            updateSharedData(updatedData);

            confimPaymentDetails(updatedData)

           
          } else {
            setErrorMessage(lang?.unexpectedPaymentStatus, paymentIntent.status)
            console.log('Unexpected payment status:', paymentIntent.status);
          }
      }
  }
  const confimPaymentDetails = (sharedDataObj)  => {
    const originalString = sharedDataObj?.donationAmount?.currency;
    const lowercaseStringCurrency = originalString?.toLowerCase();
    const apiReq = {
      // "donorDetails": sharedData?.donorData || {},
      "amount": sharedDataObj?.donationAmount?.totalAmount,
      "youGive":sharedDataObj?.donationAmount?.youGive,
      "givesomeTip": sharedDataObj?.donationAmount?.givesomeTip,
      "givesomeTipPercentage": sharedDataObj?.donationAmount?.givesomeTipPercentage,
      "givecardAmount":Number(sharedDataObj?.rewardApplied?.creditApplied),
      "givecardId":Number(sharedDataObj?.rewardApplied?.givecardId) || Number(sharedDataObj?.applyCardData?.givecardId),
      "givacardBalance":Number(sharedDataObj?.rewardApplied?.givacardBalance),
      "currency": lowercaseStringCurrency,
      "description": sharedDataObj?.donationAmount?.description+' (to '+sharedDataObj.projectName+')',
      "projectId": sharedDataObj?.projectId,
      "supplierId": sharedDataObj?.supplier_id || "",
      "givecardCode": sharedDataObj?.rewardApplied?.rewardCode?.toUpperCase() || "",
      "userId": sharedDataObj?.userId  !== "None"  ? sharedDataObj?.userId : null,
      "paymentIntentId": sharedDataObj?.paymentIntent?.paymentIntentId,
      "isEmailOptIn": sharedDataObj?.venorId ? (sharedDataObj?.isemailoptIn ? true : false): null,
      "vendorId": sharedDataObj?.venorId || null,
      "isSaveCardDetails": sharedDataObj?.isSaveCardDetails || false,
    }
    if(sharedDataObj?.singlePaymentMethodId && sharedDataObj?.singlePaymentMethodId !== "" ) {
      retrievePaymentDetails(apiReq).then((response) => {
            if(response.code && response.code  !== "") {
              return
            }
            if (response && response.data && response.data.status === 200) {
                const confirmPaymentId = response.data.data?.paymentId;
                if (confirmPaymentId) {
                  const withPaymentId = { ...sharedDataObj, confirmPaymentId };
                  updateSharedData(withPaymentId);
                }
                if(sharedDataObj?.isArtistOrInfluencer && sharedDataObj?.userId && sharedDataObj?.userId !== "None") {
                  handleNext(2)
                } else if (sharedDataObj?.enableReceipting) {
                  handleNext(4);
                } else {
                  handleNext(3);
                }
            }
            if (response && response.data && response.data.status !== 200) {
              // setErrorMessage(response.data.message);
            }
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          //   setErrorMessage(error.message);
          });
        }
  }

  const paymentElementOptions = {
    layout: "tabs",
  }

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
        <Typography className='query-head mb-40'>{lang?.howWouldYouLiketoPay}?</Typography>
        {errorMessage  !== ''  &&  <Alert className='mb-20' severity="error">{errorMessage}</Alert>}
      <PaymentElement  id="payment-element" options={paymentElementOptions} />
      {/* <div className='flex-space-btw mt-40'>
          <Typography className="normal-text mb-10">{lang?.pinCreditApplied}</Typography>
          <Typography className="normal-text mb-10">{sharedData?.donationAmount?.currencySymbol} {sharedData?.donationAmount?.creditApplied ? (sharedData?.donationAmount?.creditApplied.toString().includes(".") ? sharedData?.donationAmount?.creditApplied : sharedData?.donationAmount?.creditApplied+".00" ) : 0.00} </Typography>
      </div> */}
      <div className='flex-space-btw mt-40'>
          <Typography className="normal-text mb-10">{lang?.yourDonation}</Typography>
          <Typography className="normal-text mb-10">{sharedData?.donationAmount?.currencySymbol}{sharedData?.donationAmount?.youGive ? (sharedData?.donationAmount?.youGive.toString().includes(".") ? sharedData?.donationAmount?.youGive : sharedData?.donationAmount?.youGive+".00") :0.00}</Typography>
      </div>
       <div className="flex-space-btw">
            <Typography className="normal-text mb-10">{lang?.GivesomeTip}</Typography>
            <Typography className="normal-text mb-10">{sharedData?.donationAmount?.currencySymbol} {sharedData?.donationAmount?.givesomeTip.toString().includes(".") ? sharedData?.donationAmount?.givesomeTip.toFixed(2) : sharedData?.donationAmount?.givesomeTip+".00"}</Typography>
          </div>
      <div className='flex-space-btw mb-20'>
          <Typography className="sub-head mb-10">{lang?.total}</Typography>
          <Typography className="sub-head mb-10" style={{textTransform: 'uppercase'}}>{sharedData?.donationAmount?.currency} {sharedData?.donationAmount?.currencySymbol}{sharedData?.donationAmount?.totalAmount?.toFixed(2) || 0.00}</Typography>
      </div>
      {sharedData?.userId && sharedData?.userId !== 'None' && !sharedData?.donationAmount?.isRecurringEnabled && (
      <FormGroup>
        <FormControlLabel className="input-checkbox mb-20"  control={
          <Checkbox
          sx={{
            color: 'rgba(93, 66, 148, 1)',
            '&.Mui-checked': {
              color: 'rgba(93, 66, 148, 1)',
            },
          }}
          checked={saveCardForFutureUse}
          onChange={handleCheckboxChange}
        />
        } label="Save this Credit Card information for the future" />
      </FormGroup>
      )}
      <Button type='submit' className={`normal-text next-btn ${!stripe  ? 'payment-disabled' : ''}`}  variant='contained' disabled={!stripe || isProcessing}>
        {!stripe || isProcessing ? (<><CircularProgress className='progress-color' /><span style={{color:'#fff'}}>{lang?.processing}</span></>) : <span>{lang?.confirmDonation}</span>}
      </Button>

      {/* {sharedData?.paymentMethodId.length !== 0 && sharedData?.paymentIntent?.paymentCardDetails.length !== 0  && (  
        <><div className="or-divider-holder">
          <Divider className="divider3" />
          <div className="or-style normal-text"><b>{lang?.or}</b></div>
          <Divider className="divider3" />
        </div>
        <Button onClick={handleConfirmDirectPay} className={`normal-text next-btn ${!stripe ? 'payment-disabled' : ''}`} variant='contained' disabled={!stripe || isPayProcessing}>
            {!stripe || isPayProcessing ? (<><CircularProgress className='progress-color' /><span style={{ color: '#fff' }}>{lang?.processing}</span></>) : <span> {lang?.pay} {sharedData?.donationAmount?.currencySymbol}{sharedData?.donationAmount?.youGive || 0.00} <span style={{textTransform: 'lowercase'}}>{lang?.with}</span> {sharedData?.paymentIntent?.paymentCardDetails?.cardBrand} *{sharedData?.paymentIntent?.paymentCardDetails?.cardLastFourDigit}</span>}
          </Button></>
      )} */}
      {sharedData?.paymentMethodId?.length !== 0 && uniquePaymentCardDetails?.length !== 0  &&
        uniquePaymentCardDetails?.map((cardDetails, index) => (
          <div key={index}>
            <div className="or-divider-holder">
              <Divider className="divider3" />
              <div className="or-style normal-text">
                <b>{lang?.or}</b>
              </div>
              <Divider className="divider3" />
            </div>
            <Button
              onClick={() => handleConfirmDirectPay(cardDetails?.paymentMethodId)}
              className={`normal-text next-btn ${!stripe ? 'payment-disabled' : ''}`}
              variant="contained"
              disabled={!stripe || paymentProcessing[cardDetails?.paymentMethodId]}
            >
              {!stripe || paymentProcessing[cardDetails?.paymentMethodId] ? (
                <>
                  <CircularProgress className="progress-color" />
                  <span style={{ color: '#fff' }}>{lang?.processing}</span>
                </>
              ) : (
                <span>
                  {lang?.pay} {sharedData?.donationAmount?.currencySymbol}
                  {sharedData?.donationAmount?.totalAmount?.toFixed(2) || 0.00}
                  <span style={{ textTransform: 'lowercase' }}> {lang?.with} </span> {cardDetails.cardBrand} *{cardDetails.cardLastFourDigit}
                </span>
              )}
            </Button>
          </div>
        ))}



  </form>
  );
}

export default CheckoutForm;